/**
 * @generated SignedSource<<6d17d9ed478fc0ae12192e04d5a2dc9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "PENDING_APPROVAL" | "WAITING_IN_PERSON" | "WAITING_VIRTUAL" | "%future added value";
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
export type GuildMembershipStatus = "ACTIVE" | "DENIED" | "PENDING" | "%future added value";
export type StripePaymentIntentStatuses = "CANCELED" | "PROCESSING" | "REQUIRES_ACTION" | "REQUIRES_CAPTURE" | "REQUIRES_CONFIRMATION" | "REQUIRES_PAYMENT_METHOD" | "SUCCEEDED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventAttendButtonHybridAttend_event$data = {
  readonly attendeeForm: {
    readonly rowId: string;
  } | null | undefined;
  readonly eventTicketingTiers: {
    readonly totalCount: number;
  };
  readonly hasExternalUrl: boolean | null | undefined;
  readonly hasVenue: boolean | null | undefined;
  readonly myAttendance: {
    readonly paymentStatus: StripePaymentIntentStatuses | null | undefined;
    readonly status: EventAttendeeStatus;
  } | null | undefined;
  readonly owner: {
    readonly __typename: "Guild";
    readonly myMembership: {
      readonly membershipLevel: GuildMembershipLevel;
      readonly status: GuildMembershipStatus;
    } | null | undefined;
    readonly slugId: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly prettyUrl: string;
  readonly rowId: string;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonButton_event" | "EventAttendButtonSelectTriggerButton_event">;
  readonly " $fragmentType": "EventAttendButtonHybridAttend_event";
};
export type EventAttendButtonHybridAttend_event$key = {
  readonly " $data"?: EventAttendButtonHybridAttend_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventAttendButtonHybridAttend_event">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rowId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventAttendButtonHybridAttend_event",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prettyUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVenue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slugId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "GuildMembership",
              "kind": "LinkedField",
              "name": "myMembership",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "membershipLevel",
                  "storageKey": null
                },
                (v1/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "Guild",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "SORT_ORDER_ASC",
            "CREATED_AT_ASC"
          ]
        }
      ],
      "concreteType": "EventTicketingTiersConnection",
      "kind": "LinkedField",
      "name": "eventTicketingTiers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": "eventTicketingTiers(orderBy:[\"SORT_ORDER_ASC\",\"CREATED_AT_ASC\"])"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Form",
      "kind": "LinkedField",
      "name": "attendeeForm",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonButton_event"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventAttendButtonSelectTriggerButton_event"
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "51ccdcc3b38a19b7da54d611d4a241df";

export default node;
